<template>
    <div class="card shadow h-100">
        <div class="card-header text-center bg-sucess">Nouvelles taches</div>
        <div class="card-body p-0">
            <div class="todos-container">
                <h4>Nouvelles taches</h4>
                <div v-if="todos.length > 0">
                    <b-card
                        v-for="todo in todos"
                        :key="todo.id"
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <!-- <p class="todo-client">{{todo.client.name}}</p> -->
                        <p class="todo-created">
                            {{ todo.created_at_for_humans }} par
                            {{ todo.created_by.name }}
                        </p>
                        <hr class="mb-1 mt-1" />
                        <p class="todo-description">{{ todo.description }}</p>
                        <p
                            v-if="todo.achievement_date === null"
                            class="todo-deadline"
                        >
                            Affectée à {{ todo.assigned_to.initials }} pour le
                            {{ todo.deadline_date | moment('D/M/Y') }}
                        </p>
                        <p v-else class="todo-deadline">
                            Réalisée par {{ todo.assigned_to.initials }} le
                            {{ todo.achievement_date | moment('D/M/Y') }}
                        </p>
                    </b-card>
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="comment-description">
                            Aucune tâche n'a été affectée à ce tiers
                        </p>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientNewToDos',

    props: {
        client: 0,
    },

    data() {
        return {
            todos: [],
        }
    },

    async created() {
        await this.getTodos()
    },

    methods: {
        async getTodos() {
            {
                try {
                    const response = await axios.get(
                        `/todo/home/${this.client}`
                    )
                    this.todos = response.data.data
                } catch (error) {
                    console.log(error)
                }
            }
        },
    },
}
</script>

<style scoped>
.todos-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.todo-client {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
}

.todo-description {
    margin-bottom: 0;
}

.todo-created {
    font-size: 11px;
    margin-bottom: 0;
    font-style: italic;
}

.todo-deadline {
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 0;
}
</style>
